
const routesMenu = [
    // 首页
    {
      path: '/home',
      name: 'Home',
      component: () => import('../views/Home.vue'),
      title: '极书'
    },
    // 产品介绍
    // {
    //   path: '/product',
    //   name: 'Products',
    //   component: () => import('../views/Products.vue'),
    //   title: '产品介绍'
    // },
    // 解决方案
    {
      path: '/programme',
      name: 'Programme',
      component: () => import('../views/Programme.vue'),
      title: '解决方案'
    },
    // 合作伙伴
    {
      path: '/partner',
      name: 'Partner',
      component: () => import('../views/Partner.vue'),
      title: '产品与服务'
    },
    {
      path: '/contact',
      name: 'Contact',
      component: () => import('../views/foot/Contact.vue'),
      title: '联系我们'
    },
    // 版本
    {
      path: '/edition',
      name: 'Edition',
      component: () => import('../views/Edition.vue'),
      title: '更新日志'
    },
    // 媒体介绍
    {
      path: '/media',
      name: 'Media',
      component: () => import('../views/foot/Media.vue'),
      title: '关于我们',
      ishide: true
    },
    // 媒体介绍详情
    {
      path: '/mediaDetail',
      name: 'MediaDetail',
      component: () => import('../views/foot/MediaDetail.vue'),
      title: '更新日志',
      ishide: true
    },

  ]

  export default routesMenu



// WEBPACK FOOTER //
// ./src/plugins/Menu.js